import { render } from "./Wholesale.vue?vue&type=template&id=d3cf243c"
import script from "./Wholesale.vue?vue&type=script&lang=js"
export * from "./Wholesale.vue?vue&type=script&lang=js"

import "./Wholesale.vue?vue&type=style&index=0&id=d3cf243c&lang=css"
script.render = render

export default script